module.exports = __webpack_public_path__ + "static/img/rs_banner.04371b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/rs_banner.png
// module id = mj5j
// module chunks = 1